import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent } from 'services/analytics';

// https://data-portal.internal.atlassian.com/analytics/registry/87311
const trackStatsSnapshotLinkClick = (
  snapshotKey: string,
  snapshotValue: number | string,
  isPersonalView: boolean,
) => {
  sendUIEvent({
    source: SCREEN_NAME.PROFILE,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'unifiedProfileStatsSnapshot',
    attributes: {
      snapshotKey,
      snapshotValue,
    },
    isPersonalView,
  });
};

export { trackStatsSnapshotLinkClick };
